// extracted by mini-css-extract-plugin
export default {"withCookieBanner":"languageSelector_withCookieBanner"};